import { denormalize } from 'normalizr';
import { pathOr } from 'ramda';
import reduceReducers from 'reduce-reducers';

import { createEntitiesReducer } from 'modules/common/redux';

import { types } from './actions';
import { notificationSchema } from './entities';

const initialState = {
  entities: {},
  isFetchingNotifications: false,
  isFetchingPageNotifications: false,
  isFetchingListNotifications: false,
  isMarkingNotificationsRead: false,
  isShowingOnlyUnread: false,
  socketToken: null,
  currentPage: 1,
  pageNotificationIds: [],
  listNotificationIds: [],
};

const notificationsEntitiesReducer = createEntitiesReducer(
  ['notifications'],
  [
    types.ENTITIES_NOTIFICATIONS_RECEIVE,
    types.ENTITIES_LIST_NOTIFICATIONS_RECEIVE,
    types.ENTITIES_PAGE_NOTIFICATIONS_RECEIVE,
  ],
);

const reducer = (state = initialState, action) => {
  const { payload, type } = action;
  switch (type) {
    case types.REMOVE_NOTIFICATIONS_FROM_PAGE_NOTIFICATION_IDS: {
      return {
        ...state,
        pageNotificationIds: state.pageNotificationIds.filter(
          (id) => !payload.idsToRemove.includes(parseInt(id)),
        ),
      };
    }
    case types.ENTITIES_NOTIFICATIONS_RECEIVE: {
      /*
      1. We recieve all notifications into the entity store
      so we must build a list of ids to keep track of unacknowledged ones
      */
      const notificationsHash = pathOr(
        {},
        ['entities', 'notifications'],
        payload,
      );
      const payloadNotifications = Object.keys(notificationsHash);
      let totalListNotificationIds =
        state.listNotificationIds.concat(payloadNotifications);
      totalListNotificationIds = totalListNotificationIds
        .filter((id, index) => totalListNotificationIds.indexOf(id) === index)
        .sort((a, b) => b - a);

      let totalPageNotificationIds = state.pageNotificationIds;
      if (state.currentPage === 1) {
        totalPageNotificationIds =
          totalPageNotificationIds.concat(payloadNotifications);
        totalPageNotificationIds = totalPageNotificationIds
          .filter((id, index) => totalPageNotificationIds.indexOf(id) === index)
          .sort((a, b) => b - a)
          .slice(0, 10);
      }
      return {
        ...state,
        listNotificationIds: totalListNotificationIds,
        pageNotificationIds: totalPageNotificationIds,
      };
    }
    case types.ENTITIES_LIST_NOTIFICATIONS_RECEIVE: {
      const notificationsHash = pathOr(
        {},
        ['entities', 'notifications'],
        payload,
      );
      const payloadNotifications = Object.keys(notificationsHash);
      let totalIds = state.listNotificationIds.concat(payloadNotifications);
      totalIds = totalIds
        .filter((id, index) => totalIds.indexOf(id) === index)
        .sort((a, b) => b - a);
      return {
        ...state,
        listNotificationIds: totalIds,
      };
    }
    case types.ENTITIES_PAGE_NOTIFICATIONS_RECEIVE: {
      const notificationsHash = pathOr(
        {},
        ['entities', 'notifications'],
        payload,
      );
      const payloadNotifications = new Set(Object.keys(notificationsHash));
      return {
        ...state,
        pageNotificationIds: Array.from(payloadNotifications).sort(
          (a, b) => b - a,
        ),
      };
    }
    case types.INIT_NOTIFICATIONS_REQUEST:
      return {
        ...state,
        listNotificationIds: [],
        pageNotificationIds: [],
      };
    case types.MARK_ALL_NOTIFICATIONS_READ_SUCCESS: {
      return {
        ...state,
        isMarkingNotificationsRead: false,
      };
    }
    case types.MARK_ALL_NOTIFICATIONS_READ_ERROR:
      return {
        ...state,
        isMarkingNotificationsRead: false,
      };
    case types.MARK_ALL_NOTIFICATIONS_READ_REQUEST:
      return {
        ...state,
        isMarkingNotificationsRead: true,
      };
    default:
      return state;
  }
};

const getScope = (state) => state.modules.notifications;

export const isShowingOnlyUnread = (state) =>
  getScope(state).isShowingOnlyUnread;

export const getNotificationById = (state, id) =>
  denormalize(id, notificationSchema, getScope(state).entities);

export default reduceReducers(
  notificationsEntitiesReducer,
  reducer,
  initialState,
);
